var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "BulkOrderbysea" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_FBA_order")))]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "OrderQueryConditions",
          attrs: {
            "label-position": _vm.labelPosition,
            model: _vm.OrderQueryConditions
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_Tracking_number") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("i18n_please_enter") },
                model: {
                  value: _vm.OrderQueryConditions.OrderCode,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "OrderCode", $$v)
                  },
                  expression: "OrderQueryConditions.OrderCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_PO_number") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("i18n_please_enter") },
                model: {
                  value: _vm.OrderQueryConditions.pro,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "pro", $$v)
                  },
                  expression: "OrderQueryConditions.pro"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_Clients_tracking_number") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("i18n_please_enter") },
                model: {
                  value: _vm.OrderQueryConditions.customerNo,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "customerNo", $$v)
                  },
                  expression: "OrderQueryConditions.customerNo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_receving_warehosue") } },
            [
              _c("el-cascader", {
                ref: "changefromFABck",
                staticStyle: { width: "200px" },
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("i18n_Please_choose_original_wareohuse"),
                  options: _vm.FBAfromCk,
                  props: _vm.FBAdataprops
                },
                on: {
                  change: function($event) {
                    return _vm.changefromFABck(_vm.thatALLcklist)
                  }
                },
                model: {
                  value: _vm.thatALLcklist,
                  callback: function($$v) {
                    _vm.thatALLcklist = $$v
                  },
                  expression: "thatALLcklist"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_destination") } },
            [
              _c("el-cascader", {
                ref: "changetoFABck",
                staticStyle: { width: "200px" },
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("i18n_please_choose_your_destination"),
                  options: _vm.FBAtoCk,
                  props: _vm.toFBAdataprops
                },
                on: {
                  change: function($event) {
                    return _vm.changetoFABck(_vm.thatFBAcklist)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return [
                        _c("span", [_vm._v(_vm._s(data.namec))]),
                        _vm._v(" "),
                        !node.isLeaf ? _c("span") : _vm._e()
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.thatFBAcklist,
                  callback: function($$v) {
                    _vm.thatFBAcklist = $$v
                  },
                  expression: "thatFBAcklist"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_shipment_arrival_time") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  clearable: "",
                  "range-separator": "-",
                  "start-placeholder": _vm.$t("i18n_started_date"),
                  "end-placeholder": _vm.$t("i18n_end_date")
                },
                model: {
                  value: _vm.OrderQueryConditions.inHouseData,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "inHouseData", $$v)
                  },
                  expression: "OrderQueryConditions.inHouseData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "350px" },
              attrs: { label: _vm.$t("i18n_Order_date") }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  clearable: "",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "-",
                  "start-placeholder": _vm.$t("i18n_started_date"),
                  "end-placeholder": _vm.$t("i18n_end_date")
                },
                model: {
                  value: _vm.OrderQueryConditions.EntrustmentData,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "EntrustmentData", $$v)
                  },
                  expression: "OrderQueryConditions.EntrustmentData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "30px" },
              attrs: { type: "primary" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: {
            "tab-click": function($event) {
              return _vm.handleClick(_vm.activeName)
            }
          },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        _vm._l(_vm.tabsList, function(item, key) {
          return _c(
            "el-tab-pane",
            {
              key: key,
              attrs: { label: _vm.$t(item.staus_desc), name: item.order_status }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  refInFor: true,
                  staticStyle: { width: "95%", "margin-left": "32px" },
                  attrs: {
                    border: "",
                    align: "center",
                    data: _vm.tableData,
                    "max-height": "580",
                    "tooltip-effect": "dark",
                    "header-cell-style": { background: "#F3F3F3" }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("i18n_Serial_number"),
                      width: "70px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nos",
                      label: _vm.$t("i18n_Tracking_number"),
                      "show-overflow-tooltip": "",
                      width: "200px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pro",
                      label: _vm.$t("i18n_PO_number"),
                      "show-overflow-tooltip": "",
                      width: "180px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerNo",
                      label: _vm.$t("i18n_Clients_tracking_number"),
                      "show-overflow-tooltip": "",
                      width: "180px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warehousename",
                      label: _vm.$t("i18n_receving_warehosue"),
                      "show-overflow-tooltip": "",
                      width: "150px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recgoodscountry",
                      label: _vm.$t("i18n_destined_country"),
                      "show-overflow-tooltip": "",
                      width: "100px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recgoodsname",
                      label: _vm.$t("i18n_destination"),
                      width: "140px",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_shipment_information"),
                      "show-overflow-tooltip": "",
                      width: "200px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.beforeGoodsList.length
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center"
                                          }
                                        },
                                        _vm._l(
                                          scope.row.beforeGoodsList,
                                          function(item, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.goodstype) +
                                                  "* " +
                                                  _vm._s(item.number) +
                                                  " " +
                                                  _vm._s(item.cbm) +
                                                  "CBM\n                  " +
                                                  _vm._s(item.weight) +
                                                  "KG\n                "
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-wrapper",
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .goodstype
                                              ) +
                                              "*\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .number
                                              ) +
                                              "\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0].cbm
                                              ) +
                                              "CBM\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .weight
                                              ) +
                                              "KG\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_Accurated_package_info"),
                      "show-overflow-tooltip": "",
                      width: "200px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.goodsList.length
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center"
                                          }
                                        },
                                        _vm._l(scope.row.goodsList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.goodstype) +
                                                "* " +
                                                _vm._s(item.number) +
                                                " " +
                                                _vm._s(item.cbm) +
                                                "CBM\n                  " +
                                                _vm._s(item.weight) +
                                                "KG\n                "
                                            )
                                          ])
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-wrapper",
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].goodstype
                                              ) +
                                              "*\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].number
                                              ) +
                                              "\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].cbm
                                              ) +
                                              "CBM\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].weight
                                              ) +
                                              "KG\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("-")])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_estimated_cost"),
                      "show-overflow-tooltip": "",
                      width: "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.costbeforeinfo.amount1
                                      ? scope.row.costbeforeinfo.amount1
                                      : 0.0
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_destined_isChoseSafe"),
                      "show-overflow-tooltip": "",
                      width: "100px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row.checkInsurance ? "是" : "否"
                                      )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_actual_cost"),
                      "show-overflow-tooltip": "",
                      width: "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.costinfo.amount2 != "0.00"
                                      ? scope.row.costinfo.amount2
                                      : "-"
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: _vm.$t("i18n_Tracking"),
                      "show-overflow-tooltip": "",
                      width: "240px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "operation",
                      label: _vm.$t("i18n_Operation"),
                      width: "120px",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-dropdown",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "el-dropdown-link",
                                      staticStyle: { cursor: "pointer" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("i18n_Operation"))
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticStyle: {
                                        "box-sizing": "border-box",
                                        padding: "6px",
                                        "padding-top": "0px"
                                      },
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          staticStyle: {
                                            width: "62px",
                                            height: "32px",
                                            "line-height": "32px",
                                            background: "#409eff",
                                            color: "#fff",
                                            "border-radius": "5px",
                                            "text-align": "center",
                                            padding: "0px 6px",
                                            "margin-top": "6px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.orderdetails(scope)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("i18n_view_details")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          staticStyle: {
                                            width: "62px",
                                            height: "32px",
                                            "line-height": "32px",
                                            background: "#67c23a",
                                            color: "#fff",
                                            "border-radius": "5px",
                                            "text-align": "center",
                                            "margin-top": "6px",
                                            padding: "0px 6px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.downLoadLabel(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("i18n_download_labels")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      scope.row.state == 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: {
                                                width: "62px",
                                                height: "32px",
                                                "line-height": "32px",
                                                background: "#f56c6c",
                                                color: "#fff",
                                                "border-radius": "5px",
                                                "text-align": "center",
                                                "margin-top": "6px",
                                                padding: "0px 6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.disableOrder(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("i18n_Cancel")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.state == 3
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: {
                                                width: "62px",
                                                height: "32px",
                                                "line-height": "32px",
                                                background: "#f56c6c",
                                                color: "#fff",
                                                "border-radius": "5px",
                                                "text-align": "center",
                                                "margin-top": "6px",
                                                padding: "0px 6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteOrder(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("i18n_delete")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c("el-pagination", {
            staticStyle: {
              margin: "20px",
              "margin-left": "32px",
              float: "left"
            },
            attrs: {
              "current-page": _vm.curPageL,
              "pager-count": 5,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.pagesize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a79942b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a79942b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/FBAheader/FBAheader.vue
// module id = null
// module chunks = 